import { MaskLine } from "@/lib/motion";
import { motion } from "framer-motion";

export default function PageHero({ eyebrow, title, italic, subtitle }) {
  return (
    <section data-testid="page-hero" className="relative pt-40 lg:pt-48 pb-16 lg:pb-20">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-8">
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ duration: 0.6 }} className="flex items-center gap-4 mb-7">
          <span className="h-px w-12 bg-[#C85A32]" />
          <span className="text-xs uppercase tracking-[0.3em] text-[#4A5A4E]">{eyebrow}</span>
        </motion.div>
        <h1 className="font-serif-display text-[#1A3322] tracking-tighter leading-[0.92] text-6xl sm:text-8xl lg:text-9xl">
          <MaskLine delay={0.1}>{title}</MaskLine>
          {italic && <MaskLine delay={0.25} className="italic font-light text-[#C85A32]">{italic}</MaskLine>}
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="mt-8 max-w-2xl text-lg leading-relaxed text-[#4A5A4E]"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
